"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS_UNIT_TO_MM = void 0;
exports.parseSymbolCss = parseSymbolCss;
exports.CSS_UNIT_TO_MM = 0.129032;
function parseSymbolCss(content) {
    const lines = [];
    const arcs = [];
    const pins = [];
    const properties = [];
    const texts = [];
    const rawLines = content.split(/\r?\n/);
    for (let i = 0; i < rawLines.length; i++) {
        const line = rawLines[i].trim();
        if (line.length === 0 || line === '+') {
            continue;
        }
        const recordType = line[0];
        const rest = line.slice(1).trim();
        switch (recordType) {
            case 'L':
            case 'M': {
                const parsed = parseLineRecord(rest);
                if (parsed !== null) {
                    lines.push(parsed);
                }
                break;
            }
            case 'A': {
                const parsed = parseArcRecord(rest);
                if (parsed !== null) {
                    arcs.push(parsed);
                }
                break;
            }
            case 'C': {
                const parsed = parsePinRecord(rest);
                if (parsed !== null) {
                    pins.push(parsed);
                }
                break;
            }
            case 'P':
            case 'X': {
                const parsed = parsePropertyRecord(recordType, rest);
                if (parsed !== null) {
                    properties.push(parsed);
                }
                break;
            }
            case 'T': {
                const parsed = parseTextRecord(rest);
                if (parsed !== null) {
                    const next = rawLines[i + 1]?.trim();
                    if (next !== undefined && next.length > 0 && !isRecordHeader(next)) {
                        parsed.value = next;
                        i++;
                    }
                    texts.push(parsed);
                }
                break;
            }
        }
    }
    return { lines, arcs, pins, properties, texts };
}
const RECORD_HEADERS = new Set(['L', 'M', 'A', 'C', 'P', 'X', 'T']);
function isRecordHeader(line) {
    return line.length > 0 && RECORD_HEADERS.has(line[0]) && (line.length === 1 || line[1] === ' ' || line[1] === '\t');
}
function parseArcRecord(body) {
    const t = tokenize(body);
    if (t.length < 5) {
        return null;
    }
    const cx = parseFloat(t[0]);
    const cy = parseFloat(t[1]);
    const radius = parseFloat(t[2]);
    const startDeg = parseFloat(t[3]);
    const endDeg = parseFloat(t[4]);
    if ([cx, cy, radius, startDeg, endDeg].some((v) => Number.isNaN(v))) {
        return null;
    }
    return { type: 'A', cx, cy, radius, startDeg, endDeg };
}
function tokenize(body) {
    const tokens = [];
    let i = 0;
    while (i < body.length) {
        const ch = body[i];
        if (ch === ' ' || ch === '\t') {
            i++;
            continue;
        }
        if (ch === '"') {
            const end = body.indexOf('"', i + 1);
            if (end < 0) {
                tokens.push(body.slice(i + 1));
                i = body.length;
                break;
            }
            tokens.push(body.slice(i + 1, end));
            i = end + 1;
            continue;
        }
        let end = i;
        while (end < body.length && body[end] !== ' ' && body[end] !== '\t') {
            end++;
        }
        tokens.push(body.slice(i, end));
        i = end;
    }
    return tokens;
}
function parseLineRecord(body) {
    const t = tokenize(body);
    if (t.length < 4) {
        return null;
    }
    const x1 = parseFloat(t[0]);
    const y1 = parseFloat(t[1]);
    const x2 = parseFloat(t[2]);
    const y2 = parseFloat(t[3]);
    if (Number.isNaN(x1) || Number.isNaN(y1) || Number.isNaN(x2) || Number.isNaN(y2)) {
        return null;
    }
    return { type: 'L', x1, y1, x2, y2 };
}
function parsePinRecord(body) {
    const t = tokenize(body);
    if (t.length < 5) {
        return null;
    }
    const hotX = parseFloat(t[0]);
    const hotY = parseFloat(t[1]);
    const pinNumber = t[2];
    const bodyX = parseFloat(t[3]);
    const bodyY = parseFloat(t[4]);
    if (Number.isNaN(bodyX) || Number.isNaN(bodyY) || Number.isNaN(hotX) || Number.isNaN(hotY)) {
        return null;
    }
    const orientation = t.length > 5 && /^[LRUD]$/.test(t[t.length - 1]) ? t[t.length - 1] : '';
    return { type: 'C', bodyX, bodyY, hotX, hotY, pinNumber, orientation };
}
function parsePropertyRecord(recordType, body) {
    const t = tokenize(body);
    if (t.length < 4) {
        return null;
    }
    const x = parseFloat(t[2]);
    const y = parseFloat(t[3]);
    if (Number.isNaN(x) || Number.isNaN(y)) {
        return null;
    }
    let just = null;
    if (t.length > 9) {
        const j = parseInt(t[9], 10);
        if (!Number.isNaN(j) && j >= 0 && j <= 8) {
            just = j;
        }
    }
    return { type: recordType, propName: t[0], propValue: t[1], x, y, just };
}
function parseTextRecord(body) {
    const t = tokenize(body);
    if (t.length < 2) {
        return null;
    }
    const x = parseFloat(t[0]);
    const y = parseFloat(t[1]);
    if (Number.isNaN(x) || Number.isNaN(y)) {
        return null;
    }
    const value = t.find((tok, idx) => idx >= 6 && tok.length > 0);
    return { type: 'T', x, y, value };
}
//# sourceMappingURL=cssParser.js.map